/* src/app/components/order-not-exist-modal/order-not-exist-modal.component.scss */
.wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  background: var(--background-color);
}
.wrapper .header-block {
  height: 70%;
  width: 100%;
  position: relative;
}
.wrapper .header-block ion-img {
  width: 200px;
  height: auto;
  max-width: 80%;
  object-fit: contain;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.wrapper .header-block ion-chip {
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  width: 15px;
  height: 15px;
  padding: 0px;
  z-index: 99;
}
.wrapper .header-block ion-chip ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.wrapper .footer-section {
  height: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  padding: 20px;
}
.wrapper .footer-section p {
  text-transform: uppercase;
  margin-bottom: 10px;
  text-align: center;
  color: #fff;
}
.wrapper .footer-section ion-button {
  color: #fff;
  --background: var(--ion-color-primary);
}
/*# sourceMappingURL=order-not-exist-modal.component.css.map */
